<template>
  <main>
    <div class="header">
      <div class="inner">
        <div class="navs">
          <div
            v-for="(item, i) in navs"
            :key="i"
            class="nav"
            :class="{'active': activeRoute(item)}"
          >
            <router-link
              :to="item.route"
              class="main"
            >
              {{ item.name }}
            </router-link>
          </div>
        </div>
        <div
          v-if="me"
          class="nav"
        >
          Logged in as {{ me.email }}
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  import gql from 'graphql-tag';

  export default {
    name: 'AppHeader',
    components: {},
    props: {},
    data() {
      return {
        me: null,
        navs: [
          {
            name: 'Apps',
            route: { name: 'admin/apps' },
          },
          {
            name: 'Groups',
            route: { name: 'admin/groups' },
          },
          {
            name: 'Users',
            route: { name: 'admin/users' },
          },
        ],
      };
    },
    apollo: {
      me: {
        query: gql`
        query($admin: Boolean) {
          me (admin: $admin){
            id
            name
            email
          }
        }
      `,
        variables() {
          return { admin: true };
        },
        update({ me }) {
          return me;
        },
      },

    },
    computed: {

    },
    watch: {},
    mounted() {},
    methods: {
      activeRoute(item) {
        return this.$route.fullPath.includes(item.name.toLowerCase());
      },
    },
  };
</script>


<style lang="stylus" scoped>

  .header
    background-color: blue
    height: 60px
    width: 100%
    display: flex

  .navs
    display: flex


  .inner
    display: flex
    align-items: center
    width: calc(100% - 60px)
    margin: 0 auto
    justify-content: space-between

  .nav
    color: white
    padding-bottom: 2px
    &:hover
      color: black
    &.active
      border-bottom: 1px solid white

  .nav:not(:first-child)
    margin: 0px 20px

  .nav:first-child
    margin-right: 20px

</style>
